export default "__VITE_ASSET__c8a2c52a__"